import { truncateString } from "../../../Common/CommonFunctions/TruncateString";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { DropDownPropsTypes } from "../DropDownPropsTypes";
import "../SCSS/stylesMobile.css";

function DropDown({
  handleChangeInputDropDown,
  surveyAnswers,
  questionObjVariable,
  questionId,
  isPreview,
  surveyAnswersInfo,
}: DropDownPropsTypes) {
  return (
    <div className="mobile-supplier-view-drop-down-cover">
      <select
        disabled={
          isPreview ||
          surveyAnswersInfo?.surveyStatus === EnumSurveyAnswerStatus?.COMPLETED
        }
        className="supplier-view-drop-down-select"
        onChange={(e) =>
          surveyAnswersInfo?.surveyStatus !==
            EnumSurveyAnswerStatus?.COMPLETED &&
          handleChangeInputDropDown!(questionId, e)
        }
        value={
          surveyAnswers?.[questionId]?.val
            ? `${surveyAnswers?.[questionId]?.val}|${surveyAnswers?.[questionId]?.optionId}`
            : ""
        }
      >
        <option value="">Select Dropdown</option>
        {questionObjVariable?.[questionId]?.optionInfo?.optionOrder?.map(
          (optns) => {
            return (
              <option
                key={optns}
                className="supplier-view-dropdown-select-option"
                value={`${questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[optns]?.optionName}|${optns}`}
              >
                {truncateString(
                  `${questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[optns]?.optionName}`,
                  50
                )}
              </option>
            );
          }
        )}
      </select>
    </div>
  );
}

export default DropDown;
